/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Reserva_Abonos from "../../Formularios/Reservas/Formulario_Reserva_Abonos";
import {useEffect} from "react";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.svg";
import {adaptador_abonos_movimientos} from "../../Adaptadores/adaptador_abonos_movimientos";
import {obtenerOrigenIngreso} from "../../Utilidades/obtenerOrigenIngreso";
import {guardarDocArr} from "../../../Servicios/BD/guardarDocArr";
import {ESTADOSHABITACIONES, ESTADOSRESERVAS} from "../../../Modulo_Motor_Reservas/Constantes";

const Dialogo_Abonos = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad
    } = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'uno'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        entidad.valorAbonado = obtenerTotalAbonos(entidad.abonos)
        if (entidad.estado === ESTADOSRESERVAS[6]){
            entidad.estado = ESTADOSRESERVAS[0]
        }


        iniciarCarga('Subiendo datos')

        let origen = obtenerOrigenIngreso(entidad.estado)
        let arrAbonos = adaptador_abonos_movimientos({
            abonos: entidad.abonos,
            origen: origen,
            reserva: entidad
        })

        let resultDos = await guardarDocArr({
            col: 'cajaMovimientos', arrObj: arrAbonos
        })
        nuevoAviso({aviso: 'Movimiento en caja realizado'})

        entidad.abonos = arrAbonos
        let result = await guardarDoc('reservas', entidad)
        nuevoAviso({aviso: 'Reserva actualizada'})


        if (result.res && resultDos.res) {
            terminar({aviso: 'Datos actualizados con exito'})
        } else {
            terminar({aviso: 'Ups! no se subieron los datos, intentalo nuevamente', variante: 'error'})
        }

    }


    const obtenerTotalAbonos = (arrAbonos) => {

        let total = 0
        for (let i = 0; i < arrAbonos.length; i++) {
            total += parseInt(arrAbonos[i].valor)
        }

        return total
    }


    useEffect(() => {

        let total = props.getValues('valor')
        let abonos = props.getValues('abonos')

        if (abonos) {
            let valorAbonos = obtenerTotalAbonos(abonos)
            props.setValue('valorSaldo', total - valorAbonos)
        } else {
            props.setValue('valorSaldo', total)
        }


    }, [props]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}   >
                <Formulario_Reserva_Abonos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Abonos